export const hashRoute = subpath => `#/Puppet/${subpath}`;
export const route = subpath => hashRoute(subpath).substring(1);
export const activeTab = path => path.split('/')[2];



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_puppet-4.0.1/webpack/src/Extends/Host/PuppetTab/helpers.js